import { inject, Injectable, signal } from '@angular/core';
import { AppMenuService, REM_IN_PX, RouteDef } from '@cumlaude/shared-components-menu';
import { AuthService } from '@cumlaude/shared-authentication';
import { Params } from '@angular/router';
import { AdminRouteData } from './admin-routes.service';

const NAME_LABEL_SIZE = 11;

@Injectable({
	providedIn: 'root',
})
export class AdminMenuService extends AppMenuService<AdminRouteData> {
	readonly authService = inject(AuthService);

	rightTopLevelMenuItemSize = signal(NAME_LABEL_SIZE * REM_IN_PX).asReadonly();

	override matchTopLevelMenuQueryParams(_route: RouteDef<AdminRouteData>): Params {
		return {};
	}

	override matchTabMenuQueryParams(_route: RouteDef<AdminRouteData>): Params {
		return {};
	}

	override isTopLevelMenu(routeData: AdminRouteData): boolean {
		return routeData.base !== undefined;
	}

	getName(routeData: AdminRouteData): string {
		return routeData.name!;
	}
}
